module.exports = "../../app/cells/pages/contests/index/cta_cards_cell.rb";